import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { PHOTO_BASE_URL_Admin } from './../../Api/config';
import apiClient from '../../Api/apiClient';
import { ArrowLeft } from 'lucide-react';
import { X } from 'lucide-react';
function PDFViewer() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [showForm, setShowForm] = useState(true);
  const [PDFdata, setPDFdata] = useState(null);
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [comment, setComment] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [totalAdvertisements, setTotalAdvertisements] = useState([]);

  const [height, setHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setHeight(window.innerHeight); // Adjust to fit full viewport
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (!id) {
      navigate(-1);
      return;
    }

    const fetchPDFData = async () => {
      try {
        const response = await apiClient.get(`/user/visitor/free/${id}`);
        // console.log(response.data)
        setPDFdata(response.data.data);
      } catch (err) {
        console.error(err);
        setMessage('Failed to load PDF. Please try again later.');
      }
    };

    fetchPDFData();
  }, [id, navigate]);

  const fetchAdvertisements = async () => {
    try {
      const response = await apiClient.get('/user/add', {
        params: { panel_name: 'visitor_free_pdf' },
      });

      setTotalAdvertisements(response.data.data);
    } catch (error) {
      console.error('Error fetching advertisements:', error);
    }
  };

  useEffect(() => {
    fetchAdvertisements();
  }, []);

  const handleComplainClick = () => {
    setShowForm(!showForm);
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    setMessage('');

    try {
      const response = await apiClient.post('/user/comment', {
        name,
        tender_id: id,
        phone,
        comment,
      });

      setMessage('Complaint submitted successfully!');
      setName('');
      setPhone('');
      setComment('');
    } catch (error) {
      setMessage('Failed to submit complaint.');
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleAdClicked = link => {
    window.open(link, '_blank');
  };


const handleDownload = () => {
  const link = document.createElement('a');
  link.href = `${PHOTO_BASE_URL_Admin}${PDFdata.file_upload}`;
  link.download = `file_${id}.pdf`;

  // Programmatically trigger the download
  link.click();
};



  const handlePrint = () => {
    const printWindow = window.open('', '_blank'); // Open a new blank window

    // Add an iframe to the new window to display the PDF
    printWindow.document.write(`
    <html>
      <head>
        <title>PDF Print Preview</title>
      </head>
      <body>
        <iframe 
          src="${PHOTO_BASE_URL_Admin}${PDFdata.file_upload}" 
          width="100%" 
          height="100%" 
          style="border:none;"
        ></iframe>
      </body>
    </html>
  `);

    // Wait for the iframe to load and then trigger the print dialog
    printWindow.document.close();
    printWindow.onload = () => {
      printWindow.print(); // Trigger the print dialog
    };
  };



  if (!PDFdata) {
    return (
      <div className="py-4 mt-36 text-center">
        <h1 className="font-bold md:text-lg text-sm mb-4">
          PDF not found. Please check the URL or try again later.{' '}
          <span
            onClick={() => navigate(-1)}
            className="underline text-blue-700 cursor-pointer"
          >
            Go Back
          </span>
        </h1>
      </div>
    );
  }

  return (
    <div className="py-4 md:mt-36 mt-24 container mx-auto">
      <div className="md:px-0 items-center px-2 py-3 flex justify-between max-w-7xl">
        <h1 className="font-bold md:text-lg text-sm text-center">
          View Tender PDF
        </h1>
        <span
          // onClick={() => navigate(-1)}
          onClick={() => navigate('/')}
          className="text-blue-700 hover:text-red-600 cursor-pointer "
        >
          {/* <ArrowLeft size={16} /> */}
          <X size={20} />
        </span>
      </div>

      {/* Ad Above Main Content in Mobile View */}
      <div className="md:hidden w-full bg-gray-200 rounded-lg shadow-md p-2 text-center mb-4">
        {totalAdvertisements.length > 0 && (
          <img
            src={`${PHOTO_BASE_URL_Admin}${totalAdvertisements[0].add_file}`}
            alt={totalAdvertisements[0].name}
            className="w-full h-60 rounded-md object-cover"
          />
        )}
      </div>

      {/* Main Content and Desktop Ads */}
      <div className="flex flex-col md:flex-row bg-gray-0 px-2 py-4 md:px-0 gap-4">
        {/* Main Content */}
        <div className="w-full md:w-2/3 ">
          <h1 className="font-bold md:text-lg text-sm text-left mb-1">
            {PDFdata.name}
          </h1>
          <h2 className="text-DefaultColor mb-1 md:text-sm text-xs ">
            Submission date:{' '}
            {new Date(PDFdata.publish_on).toLocaleDateString('en-US', {
              year: 'numeric',
              month: 'long',
              day: '2-digit',
            })}{' '}
            ({PDFdata.publish_on_before} days more)
          </h2>
          <div className="w-full flex items-center justify-center text-gray-600 max-w-7xl">
            {/* <iframe
              src={`${PHOTO_BASE_URL_Admin}${PDFdata.file_upload}`}
              width="100%"
              height={`${height}px`}
              title="PDF Viewer"
              style={{ border: 'none' }}
            /> */}
            <iframe
              src={`${PHOTO_BASE_URL_Admin}${PDFdata.file_upload}`}
              width="100%"
              height={height}
              className="w-full max-w-full"
              title="PDF Viewer"
              style={{ border: 'none' }}
            />
          </div>

          {/* Download and Print Buttons */}
          <div className="flex  justify-center gap-4 mt-4">
            <button
              onClick={handleDownload}
              className="bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600 w-full sm:w-auto"
            >
              Download PDF
            </button>
            <button
              onClick={handlePrint}
              className="bg-green-500 text-white px-4 py-2 rounded-lg hover:bg-green-600 w-full sm:w-auto"
            >
              Print PDF
            </button>
          </div>

          {/* Complain Button */}
          <div className="md:mt-8 mt-4 w-full max-w-6xl flex md:justify-end justify-center">
            <button
              onClick={handleComplainClick}
              className="bg-red-500 text-white text-sm px-4 py-1 rounded-md sm:rounded-lg hover:bg-red-600"
            >
              {showForm ? 'Close ▲' : 'Complain ▼'}
            </button>
          </div>

          {/* Complaint Form */}
          {showForm && (
            <div className="transition-all duration-500 ease-in-out w-full max-w-4xl mx-auto mt-4 mb-7 px-4 sm:px-6 lg:px-8 md:text-sm text-xs">
              <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-lg mx-auto">
                <h2 className="font-semibold text-sm sm:text-lg text-[#2F383B] mb-6 text-center">
                  Help improve the service by providing feedback.
                </h2>

                <form className="space-y-4" onSubmit={handleSubmit}>
                  <div className="flex flex-col sm:flex-row items-center justify-start gap-2 sm:gap-4">
                    <label className="text-gray-600 w-full sm:w-32 ">
                      Name
                    </label>
                    <input
                      type="text"
                      className="w-full sm:flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                      placeholder="Enter your name"
                      value={name}
                      onChange={e => setName(e.target.value)}
                      required
                    />
                  </div>

                  <div className="flex flex-col sm:flex-row items-center sm:items-start gap-2 sm:gap-4">
                    <label className="text-gray-600 w-full sm:w-32 ">
                      Mobile
                    </label>
                    <input
                      type="text"
                      className="w-full sm:flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                      placeholder="Enter your mobile number"
                      value={phone}
                      onChange={e => setPhone(e.target.value)}
                      required
                    />
                  </div>

                  <div className="flex flex-col sm:flex-row items-start gap-2 sm:gap-4">
                    <label className="text-gray-600 w-full sm:w-32  mt-1 sm:mt-2">
                      Comment
                    </label>
                    <textarea
                      className="w-full sm:flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                      rows={3}
                      placeholder="Write your feedback"
                      value={comment}
                      onChange={e => setComment(e.target.value)}
                      required
                    ></textarea>
                  </div>

                  <div className="flex justify-center sm:justify-end">
                    <button
                      type="submit"
                      className="w-full sm:w-1/4 bg-red-500 text-white text-sm sm:text-base md:py-2 py-1 rounded-lg hover:bg-red-600 transition"
                      disabled={loading}
                    >
                      {loading ? 'Submitting...' : 'Submit'}
                    </button>
                  </div>

                  {message && (
                    <p className="text-center md:text-sm text-xs mt-2 text-green-500">
                      {message}
                    </p>
                  )}
                </form>
              </div>
            </div>
          )}
        </div>

        {/* Desktop Ads */}
        <div className="hidden md:block w-full md:w-1/3">
          <div className="sticky top-44 bottom-4 bg-gray-200 rounded-lg shadow-md ">
            {totalAdvertisements.length > 0 &&
              totalAdvertisements
                .sort((a, b) => a.serial - b.serial)
                .map((ad, index) => (
                  <div
                    onClick={() => handleAdClicked(ad.url_link)}
                    className="border cursor-pointer rounded-md my-2 border-black"
                    key={index}
                  >
                    <img
                      src={`${PHOTO_BASE_URL_Admin}${ad.add_file}`}
                      alt={ad.name}
                      className="w-full h-60 max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg xl:max-w-xl rounded-md object-cover"
                    />
                  </div>
                ))}
          </div>
        </div>
      </div>

      {/* Ad Below Main Content in Mobile View */}
      <div className="md:hidden w-full bg-gray-200 rounded-lg shadow-md p-2 text-center mt-4">
        {totalAdvertisements.length > 1 && (
          <img
            src={`${PHOTO_BASE_URL_Admin}${totalAdvertisements[1].add_file}`}
            alt={totalAdvertisements[1].name}
            onClick={() => handleAdClicked(totalAdvertisements[1].url_link)}
            className="w-full h-60 rounded-md object-cover cursor-pointer"
          />
        )}
      </div>
    </div>
  );
}

export default PDFViewer;

// import React, { useState, useEffect } from 'react';
// import { useParams, useNavigate } from 'react-router-dom';
// import { PHOTO_BASE_URL_Admin } from './../../Api/config';
// import apiClient from '../../Api/apiClient';
// import { ArrowLeft, Share, Share2 } from 'lucide-react';
// function PDFViewer() {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const [showForm, setShowForm] = useState(true);
//   const [PDFdata, setPDFdata] = useState(null);
//   const [name, setName] = useState('');
//   const [phone, setPhone] = useState('');
//   const [comment, setComment] = useState('');
//   const [loading, setLoading] = useState(false);
//   const [message, setMessage] = useState('');
//   const [totalAdvertisements, setTotalAdvertisements] = useState([]);

//    const [height, setHeight] = useState(window.innerHeight);

//    useEffect(() => {
//      const handleResize = () => {
//        setHeight(window.innerHeight); // Adjust to fit full viewport
//      };

//      window.addEventListener('resize', handleResize);
//      return () => window.removeEventListener('resize', handleResize);
//    }, []);

//   useEffect(() => {
//     if (!id) {
//       // console.error('ID is missing from the URL');
//       navigate(-1);
//       return;
//     }

//     const fetchPDFData = async () => {
//       try {
//         const response = await apiClient.get(`/user/visitor/free/${id}`);
//         setPDFdata(response.data.data);
//       } catch (err) {
//         console.error(err);
//         setMessage('Failed to load PDF. Please try again later.');
//       }
//     };

//     fetchPDFData();
//   }, [id, navigate]);

//   const fetchAdvertisements = async () => {
//     try {
//       const response = await apiClient.get('/user/add', {
//         params: { panel_name: 'visitor_free_pdf' },
//       });

//       // console.log("advertisement:",response.data)
//       setTotalAdvertisements(response.data.data);
//     } catch (error) {
//       console.error('Error fetching advertisements:', error);
//     }
//   };

//   useEffect(() => {
//     fetchAdvertisements();
//   }, []);

//   const handleComplainClick = () => {
//     setShowForm(!showForm);
//   };

//   const handleSubmit = async e => {
//     e.preventDefault();
//     setLoading(true);
//     setMessage('');

//     try {
//       const response = await apiClient.post('/user/comment', {
//         name,
//         tender_id: id,
//         phone,
//         comment,
//       });

//       setMessage('Complaint submitted successfully!');
//       setName('');
//       setPhone('');
//       setComment('');
//     } catch (error) {
//       setMessage('Failed to submit complaint.');
//       console.error(error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleAdClicked = link => {
//     window.open(link, '_blank');
//   };

//   if (!PDFdata) {
//     return (
//       <div className="py-4 mt-36 text-center">
//         <h1 className="font-bold md:text-lg text-sm mb-4">
//           PDF not found. Please check the URL or try again later. <span onClick={()=>{navigate(-1)}} className='underline text-blue-700 cursor-pointer'>Go Back</span>
//         </h1>
//       </div>
//     );
//   }

//   return (
//     <div className="py-4 md:mt-36 mt-28">
//       <div className="md:px-4 items-center px-2 flex justify-between">
//         <span
//           onClick={() => {
//             navigate(-1);
//           }}
//           className="text-blue-700 cursor-pointer"
//         >
//           <ArrowLeft size={16} />
//         </span>
//         <span></span>
//       </div>
//       <h1 className="font-bold md:text-lg text-sm text-center mb-4">
//         View PDF
//       </h1>

//       {/* Ad Above Main Content in Mobile View */}
//       <div className="md:hidden w-full bg-gray-200 rounded-lg shadow-md p-2 text-center mb-4">
//         {totalAdvertisements.length > 0 && (
//           <img
//             src={`${PHOTO_BASE_URL_Admin}${totalAdvertisements[0].add_file}`}
//             alt={totalAdvertisements[0].name}
//             className="w-full h-60 rounded-md object-cover"
//           />
//         )}
//       </div>

//       {/* Main Content and Desktop Ads */}
//       <div className="flex flex-col md:flex-row bg-gray-100 px-2 py-4 md:px-20 gap-4">
//         {/* Main Content */}
//         <div className="w-full md:w-2/3">
//           <h2 className="text-DefaultColor mb-1 md:text-sm text-xs">
//             Submission date:{' '}
//             {new Date(PDFdata.publish_on).toLocaleDateString('en-US', {
//               year: 'numeric',
//               month: 'long',
//               day: '2-digit',
//             })}{' '}
//             ({PDFdata.publish_on_before} days more)
//           </h2>
//           <div className="w-full flex items-center justify-center text-gray-600 max-w-7xl">
//             {/* <iframe
//               src={`${PHOTO_BASE_URL_Admin}${PDFdata.file_upload}`}
//               width="100%"
//               height="1000px"
//               title="PDF Viewer"
//             /> */}
//             <iframe
//               src={`${PHOTO_BASE_URL_Admin}${PDFdata.file_upload}`}
//               width="100%"
//               height={`${height}px`}
//               title="PDF Viewer"
//               style={{ border: 'none' }}
//             />
//           </div>

//           {/* Complain Button */}
//           <div className="md:mt-8 mt-4 w-full max-w-6xl flex md:justify-end justify-center">
//             <button
//               onClick={handleComplainClick}
//               className="bg-red-500 text-white text-sm px-4 py-1 rounded-md sm:rounded-lg hover:bg-red-600"
//             >
//               {showForm ? 'Close ▲' : 'Complain ▼'}
//             </button>
//           </div>

//           {/* Complaint Form */}
//           {showForm && (
//             <div className="transition-all duration-500 ease-in-out w-full max-w-4xl mx-auto mt-4 mb-7 px-4 sm:px-6 lg:px-8 md:text-sm text-xs">
//               <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-lg mx-auto">
//                 <h2 className="font-semibold text-sm sm:text-lg text-[#2F383B] mb-6 text-center ">
//                   Help improve the service by providing feedback.
//                 </h2>

//                 <form className="space-y-4" onSubmit={handleSubmit}>
//                   <div className="flex flex-col sm:flex-row items-center justify-start gap-2 sm:gap-4">
//                     <label className="text-gray-600 w-full sm:w-32 ">
//                       Name
//                     </label>
//                     <input
//                       type="text"
//                       className="w-full sm:flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                       placeholder="Enter your name"
//                       value={name}
//                       onChange={e => setName(e.target.value)}
//                       required
//                     />
//                   </div>

//                   <div className="flex flex-col sm:flex-row items-center sm:items-start gap-2 sm:gap-4">
//                     <label className="text-gray-600 w-full sm:w-32 ">
//                       Mobile
//                     </label>
//                     <input
//                       type="text"
//                       className="w-full sm:flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                       placeholder="Enter your mobile number"
//                       value={phone}
//                       onChange={e => setPhone(e.target.value)}
//                       required
//                     />
//                   </div>

//                   <div className="flex flex-col sm:flex-row items-start gap-2 sm:gap-4">
//                     <label className="text-gray-600 w-full sm:w-32  mt-1 sm:mt-2">
//                       Comment
//                     </label>
//                     <textarea
//                       className="w-full sm:flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                       rows={3}
//                       placeholder="Write your feedback"
//                       value={comment}
//                       onChange={e => setComment(e.target.value)}
//                       required
//                     ></textarea>
//                   </div>

//                   <div className="flex justify-center sm:justify-end">
//                     <button
//                       type="submit"
//                       className="w-full sm:w-1/4 bg-red-500 text-white text-sm sm:text-base md:py-2 py-1 rounded-lg hover:bg-red-600 transition"
//                       disabled={loading}
//                     >
//                       {loading ? 'Submitting...' : 'Submit'}
//                     </button>
//                   </div>

//                   {message && (
//                     <p className="text-center md:text-sm text-xs mt-2 text-green-500">
//                       {message}
//                     </p>
//                   )}
//                 </form>
//               </div>
//             </div>
//           )}
//         </div>

//         {/* Desktop Ads */}
//         <div className="hidden md:block w-full md:w-1/3">
//           <div className="sticky top-44 bottom-4 bg-gray-200 rounded-lg shadow-md ">
//             {totalAdvertisements.length > 0
//               ? totalAdvertisements
//                   .sort((a, b) => a.serial - b.serial)
//                   .map((ad, index) => (
//                     <div
//                       onClick={() => handleAdClicked(ad.url_link)}
//                       className="border cursor-pointer rounded-md my-2 border-black"
//                       key={index}
//                     >
//                       <img
//                         src={`${PHOTO_BASE_URL_Admin}${ad.add_file}`}
//                         alt={ad.name}
//                         className="w-full h-60 max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg xl:max-w-xl rounded-md object-cover"
//                       />
//                     </div>
//                   ))
//               : null}
//           </div>
//         </div>
//       </div>

//       {/* Ad Below Main Content in Mobile View */}
//       <div className="md:hidden w-full bg-gray-200 rounded-lg shadow-md p-2 text-center mt-4">
//         {totalAdvertisements.length > 1 && (
//           <img
//             src={`${PHOTO_BASE_URL_Admin}${totalAdvertisements[1].add_file}`}
//             alt={totalAdvertisements[1].name}
//             onClick={() => handleAdClicked(totalAdvertisements[1].url_link)}
//             className="w-full h-60 rounded-md object-cover cursor-pointer"
//           />
//         )}
//       </div>
//     </div>
//   );
// }

// export default PDFViewer;
